import clsx from "clsx";
import type { ReactNode } from "react";

interface EmptyStateProps {
  /** Says what is missing, plainly: "No documents yet". */
  title: string;
  /** Says what to do about it, or why it is empty. */
  children?: ReactNode;
  /** A button or link that does the first step. */
  action?: ReactNode;
  className?: string;
}

/** What a list or a screen shows when there is nothing in it yet. Every screen has one, never a blank page. */
export function EmptyState({ title, children, action, className }: EmptyStateProps) {
  return (
    <div className={clsx("empty-state", className)}>
      <p className="empty-state__title">{title}</p>
      {children && <div className="empty-state__body muted">{children}</div>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}

/** A short line while a screen reads its data. */
export function Loading({ children = "Loading" }: { children?: ReactNode }) {
  return (
    <p role="status" aria-busy="true" className="loading muted">
      {children}
      <span className="loading__dots" aria-hidden="true" />
    </p>
  );
}
